import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/store';

export class ColumnRowBlockModel extends BlockModel {}

export class ColumnBlockModel extends BlockModel<{ width: number }> {}

export const ColumnRowBlockSchema = defineBlockSchema({
  flavour: 'affine:column-row',
  props: () => ({}),
  metadata: {
    version: 1,
    role: 'content',
    parent: ['affine:note', 'affine:column'],
    children: ['affine:column'],
  },
  toModel: () => new ColumnRowBlockModel(),
});

export const ColumnBlockSchema = defineBlockSchema({
  flavour: 'affine:column',
  props: () => ({ width: 1 }),
  metadata: {
    version: 1,
    role: 'hub',
    parent: ['affine:column-row'],
    children: [
      '@content',
      'affine:database',
      'affine:data-view',
      'affine:callout',
    ],
  },
  toModel: () => new ColumnBlockModel(),
});

export const ColumnRowBlockSchemaExtension =
  BlockSchemaExtension(ColumnRowBlockSchema);
export const ColumnBlockSchemaExtension =
  BlockSchemaExtension(ColumnBlockSchema);
